"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPARK_QUERY_CELL_SIZE = exports.SPARK_NEAR_MERGE_CELL_SIZE = exports.SPARK_NEAR_MERGE_RADIUS = exports.WORLD_SPARK_OBJECT_CAP = exports.MAX_MERGED_SPARK_VALUE = exports.BOOST_COST_EXTRA_PER_SPARK = exports.CAMERA_SCALE_PER_SPARK = exports.SNAKE_SCALE_PER_SPARK = exports.SPARKS_PER_SEGMENT = exports.STARTER_VISUAL_LENGTH = void 0;
exports.quantizeSnakeLength = quantizeSnakeLength;
exports.snakeLengthFromEconomicSparks = snakeLengthFromEconomicSparks;
exports.increaseSnakeLengthBySparks = increaseSnakeLengthBySparks;
exports.decreaseSnakeLengthBySparks = decreaseSnakeLengthBySparks;
exports.economicSparksFromSnakeLength = economicSparksFromSnakeLength;
exports.combatLengthFromSnakeLength = combatLengthFromSnakeLength;
exports.snakeSegmentCountFromLength = snakeSegmentCountFromLength;
exports.snakeTailProgressFromLength = snakeTailProgressFromLength;
exports.snakeScaleFromLength = snakeScaleFromLength;
exports.snakeCameraScaleFromLength = snakeCameraScaleFromLength;
exports.snakeBoostCostMultiplierFromLength = snakeBoostCostMultiplierFromLength;
exports.snakeWidthFromLength = snakeWidthFromLength;
exports.snakeSegmentSpacingFromLength = snakeSegmentSpacingFromLength;
exports.snakeHeadCollisionRadiusFromLength = snakeHeadCollisionRadiusFromLength;
exports.snakeBodyCollisionRadiusFromLength = snakeBodyCollisionRadiusFromLength;
exports.snakeCollectionRadiusFromLength = snakeCollectionRadiusFromLength;
exports.encodeSnakeLengthWire = encodeSnakeLengthWire;
exports.decodeSnakeLengthWire = decodeSnakeLengthWire;
const constants_1 = require("./constants");
exports.STARTER_VISUAL_LENGTH = 10;
exports.SPARKS_PER_SEGMENT = 5;
exports.SNAKE_SCALE_PER_SPARK = 0.001;
exports.CAMERA_SCALE_PER_SPARK = 0.00025;
exports.BOOST_COST_EXTRA_PER_SPARK = 0.002;
exports.MAX_MERGED_SPARK_VALUE = 3;
exports.WORLD_SPARK_OBJECT_CAP = 14336;
exports.SPARK_NEAR_MERGE_RADIUS = 8;
exports.SPARK_NEAR_MERGE_CELL_SIZE = exports.SPARK_NEAR_MERGE_RADIUS * 2;
exports.SPARK_QUERY_CELL_SIZE = 500;
const MIN_VISUAL_LENGTH = 1;
const LENGTH_WIRE_SCALE = exports.SPARKS_PER_SEGMENT;
function clampVisualLength(length) {
    return Math.max(MIN_VISUAL_LENGTH, Math.round(length * LENGTH_WIRE_SCALE) / LENGTH_WIRE_SCALE);
}
function quantizeSnakeLength(length) {
    if (!Number.isFinite(length))
        return exports.STARTER_VISUAL_LENGTH;
    return clampVisualLength(length);
}
function snakeLengthFromEconomicSparks(sparks) {
    return quantizeSnakeLength(exports.STARTER_VISUAL_LENGTH + Math.max(0, Math.floor(sparks)) / exports.SPARKS_PER_SEGMENT);
}
function increaseSnakeLengthBySparks(length, sparks) {
    return quantizeSnakeLength(length + Math.max(0, Math.floor(sparks)) / exports.SPARKS_PER_SEGMENT);
}
function decreaseSnakeLengthBySparks(length, sparks) {
    return quantizeSnakeLength(length - Math.max(0, Math.floor(sparks)) / exports.SPARKS_PER_SEGMENT);
}
function economicSparksFromSnakeLength(length) {
    const quantized = quantizeSnakeLength(length);
    if (quantized <= exports.STARTER_VISUAL_LENGTH)
        return 0;
    return Math.max(0, Math.round((quantized - exports.STARTER_VISUAL_LENGTH) * exports.SPARKS_PER_SEGMENT));
}
function combatLengthFromSnakeLength(length) {
    const quantized = quantizeSnakeLength(length);
    if (quantized <= exports.STARTER_VISUAL_LENGTH)
        return quantized;
    return exports.STARTER_VISUAL_LENGTH + economicSparksFromSnakeLength(quantized);
}
function snakeSegmentCountFromLength(length) {
    return Math.max(1, Math.floor(quantizeSnakeLength(length)));
}
function snakeTailProgressFromLength(length) {
    const quantized = quantizeSnakeLength(length);
    const wholeSegments = Math.floor(quantized);
    return Math.max(0, Math.min(0.999, quantized - wholeSegments));
}
function snakeScaleFromLength(length) {
    return 1 + economicSparksFromSnakeLength(length) * exports.SNAKE_SCALE_PER_SPARK;
}
function snakeCameraScaleFromLength(length) {
    return 1 + economicSparksFromSnakeLength(length) * exports.CAMERA_SCALE_PER_SPARK;
}
function snakeBoostCostMultiplierFromLength(length) {
    return 1 + economicSparksFromSnakeLength(length) * exports.BOOST_COST_EXTRA_PER_SPARK;
}
function snakeWidthFromLength(length) {
    return constants_1.INITIAL_WIDTH * snakeScaleFromLength(length);
}
function snakeSegmentSpacingFromLength(length) {
    return constants_1.SEGMENT_SPACING * snakeScaleFromLength(length);
}
function snakeHeadCollisionRadiusFromLength(length) {
    return constants_1.COLLISION_RADIUS * snakeScaleFromLength(length);
}
function snakeBodyCollisionRadiusFromLength(length) {
    return constants_1.SEGMENT_COLLISION_RADIUS * snakeScaleFromLength(length);
}
function snakeCollectionRadiusFromLength(length) {
    return constants_1.INITIAL_WIDTH * snakeScaleFromLength(length);
}
function encodeSnakeLengthWire(length) {
    return Math.max(0, Math.min(0xFFFF, Math.round(quantizeSnakeLength(length) * LENGTH_WIRE_SCALE)));
}
function decodeSnakeLengthWire(value) {
    return quantizeSnakeLength(Math.max(0, Math.floor(value)) / LENGTH_WIRE_SCALE);
}
//# sourceMappingURL=snake-growth.js.map